import React from 'react';
import { withRouter } from 'react-router-dom';

import { ReservationList } from 'components/Reservations';
import Layout from 'components/Layout';
import i18n from 'i18n-js';
import PropTypes from 'prop-types';

const ReservationsList = ({ history }) => {
  return (
    <Layout title={i18n.t('reservations.title')}>
      <ReservationList type="customer" history={history} title={i18n.t('reservations.title')} />
    </Layout>
  );
};

ReservationsList.propTypes = {
  history: PropTypes.object,
};

export default withRouter(ReservationsList);
